var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaCircleInfoThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-40 0 0-136c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 128-40 0zm48-176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaCircleInfoThin);
export default __webpack_public_path__ + "static/media/fa-circle-info-thin.c8bd72a48297da734d58f4d101314dc3.svg";
export { ForwardRef as ReactComponent };